import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=dd09050e"
import script from "./snackbar.vue?vue&type=script&lang=js"
export * from "./snackbar.vue?vue&type=script&lang=js"
import style0 from "./snackbar.vue?vue&type=style&index=0&id=dd09050e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports